
export default {
    name: 'SvgBrokenQr',
};
